<ng-container *ngIf="!!onboardingWhatsNew">
    <div class="edp-widget-whats-new edp-card-widget card">
        <div class="card-header flex-column align-items-start">
            <div class="d-flex">
                <span class="card-title">{{ onboardingWhatsNew.title }}</span>
            </div>
        </div>

        <div class="card-body">
            <div class="card-body-content">
                <p [innerHTML]="onboardingWhatsNew.description"></p>
                <ng-container *ngIf="!!onboardingWhatsNew.image">
                    <img [src]="prefixPathImage + onboardingWhatsNew.image" alt="What's new">
                </ng-container>
            </div>
            <button (click)="action()" class="btn btn-primary">
                <span>{{ onboardingWhatsNew.label }}</span>
            </button>
        </div>

    </div>
</ng-container>